/**
 * Shared thumbnail sizing for the four card carousels, so the ladder is tuned
 * in one place rather than four.
 *
 * The steps are deliberately close together. With a coarse ladder the browser
 * rounds *up* to the next rung and overshoots: a card that paints at 317 CSS px
 * on a Lighthouse mobile run needs ~555 device px, and a [320, 480, 640] ladder
 * hands it the 640 — 15% more pixels and ~38% more bytes than asked for. The
 * extra rungs mean it lands on 560 instead.
 *
 * Quality 55 rather than 65: these are 16:9 thumbnails behind a play overlay,
 * never viewed full-size, and PSI flags the compression explicitly. On the
 * heaviest image the two changes together take 57.9KB down to 37.7KB.
 */
export const THUMB_WIDTHS = [320, 400, 480, 560, 640, 800, 1024, 1280] as const;

export const THUMB_QUALITY = 55;

export const thumbSrc = (base: string, path: string, width: number) =>
  `${base}/${path}?tr=f-webp,q-${THUMB_QUALITY},w-${width}`;

export const thumbSrcSet = (base: string, path: string) =>
  THUMB_WIDTHS.map((width) => `${thumbSrc(base, path, width)} ${width}w`).join(
    ", ",
  );
